

import React from "react";
import { useNavigate } from "react-router-dom";

export default function Language() {
  const navigate = useNavigate();

  const languages = [
    { code: "en", label: "English" },
    { code: "es", label: "Español" },
    { code: "fr", label: "Français" },
    { code: "de", label: "Deutsch" },
    { code: "pt", label: "Português" },
    { code: "ar", label: "العربية" },
    { code: "ja", label: "日本語" },
  ];

  const handlePick = (code) => {
    try {
      localStorage.setItem("site_lang", code);
    } catch (e) {
      // ignore storage errors
    }
    // Go back if possible; otherwise go home
    if (window.history.length > 1) navigate(-1);
    else navigate("/");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem 1rem",
        background:
          "radial-gradient(circle at top left, #ffffff 0%, #f6f4ff 45%, #ffffff 100%)",
      }}
    >
      <div
        style={{
          width: "min(820px, 100%)",
          borderRadius: 22,
          padding: "2rem 1.6rem",
          background: "rgba(255,255,255,0.92)",
          boxShadow: "0 18px 50px rgba(0,0,0,0.12)",
          border: "1px solid rgba(0,0,0,0.06)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* subtle color wash */}
        <div
          aria-hidden="true"
          style={{
            position: "absolute",
            inset: -80,
            background:
              "conic-gradient(from 200deg, rgba(255,90,138,0.20), rgba(255,194,0,0.16), rgba(0,200,255,0.16), rgba(160,110,255,0.18), rgba(255,90,138,0.20))",
            filter: "blur(34px)",
            opacity: 0.55,
          }}
        />

        <div style={{ position: "relative" }}>
          <h1
            style={{
              margin: 0,
              fontSize: "clamp(1.7rem, 3vw, 2.4rem)",
              color: "#141419",
              letterSpacing: "-0.02em",
            }}
          >
            Elige tu idioma
          </h1>
          <p style={{ margin: ".55rem 0 1.4rem", color: "#3e3e4a" }}>
            Choose your language to explore the artisan’s work.
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
              gap: ".9rem",
            }}
          >
            {languages.map((l) => (
              <button
                key={l.code}
                type="button"
                onClick={() => handlePick(l.code)}
                style={{
                  border: "1px solid rgba(0,0,0,0.10)",
                  background: "rgba(255,255,255,0.96)",
                  borderRadius: 16,
                  padding: "1rem .9rem",
                  fontWeight: 800,
                  cursor: "pointer",
                  color: "#141419",
                  boxShadow: "0 10px 22px rgba(0,0,0,0.10)",
                  transition: "transform 150ms ease, box-shadow 150ms ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 16px 30px rgba(0,0,0,0.14)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0px)";
                  e.currentTarget.style.boxShadow = "0 10px 22px rgba(0,0,0,0.10)";
                }}
              >
                {l.label}
              </button>
            ))}
          </div>

          <div style={{ marginTop: "1.25rem", display: "flex", gap: ".75rem" }}>
            <button
              type="button"
              onClick={() => navigate(-1)}
              style={{
                border: "1px solid rgba(0,0,0,0.12)",
                background: "rgba(255,255,255,0.92)",
                borderRadius: 14,
                padding: ".85rem 1rem",
                fontWeight: 800,
                cursor: "pointer",
              }}
            >
              Volver
            </button>
            <button
              type="button"
              onClick={() => navigate("/")}
              style={{
                border: "none",
                background: "#141419",
                color: "#fff",
                borderRadius: 14,
                padding: ".85rem 1rem",
                fontWeight: 800,
                cursor: "pointer",
              }}
            >
              Inicio
            </button>
          </div>

          <p style={{ margin: "1rem 0 0", color: "#5a5a6a", fontSize: ".95rem" }}>
            Tip: This selection is saved on your device.
          </p>
        </div>

        {/* responsive */}
        <style>{`
          @media (max-width: 720px){
            .lang-grid { grid-template-columns: 1fr; }
          }
        `}</style>
      </div>
    </div>
  );
}